module.exports = __webpack_public_path__ + "assets/d5eb96db8300b193ac0f14adfc74c8b5.png";